import { Command } from './Command';

export type VerifyEnumVersionParams = {
	oid: string;
	date: string;
};

export const VerifyEnumVersion = (params: VerifyEnumVersionParams): Command => {
	return {
		operation: 'OverVerziuCiselnikov_v1',
		params,
	};
};
